var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:Object.assign({}, _vm.brkPoints),attrs:{"id":"blank-layout"}},[_c('v-content',[_c('nuxt')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }